import { ErrorCode } from '@/providers/ContentProvider';
import { HttpStatusCode } from 'axios';
import { DeepKeys } from '@tanstack/react-table';
import { BaseEntity } from '@/api/EntityApi';
import { MIME_TYPES } from '@mantine/dropzone';
import LANGUAGES from '@/configs/languages';

export type Language = keyof typeof LANGUAGES;
export type ForeignLanguage = Exclude<Language, 'PL'>;
export type Translations<TData> = Record<ForeignLanguage, TData>;

export type SortOrder = 'ASC' | 'DESC';

export interface Sort<TData extends BaseEntity = any> {
	key: DeepKeys<TData> | null;
	order: SortOrder;
}

export interface ApiQueryOptions<TData extends BaseEntity = any> {
	page: number;
	limit: number;
	search?: string;
	sortBy: Sort<TData>;
}

export interface ApiPaginatedResponse<TData extends {} = {}> {
	data: TData[];
	meta: {
		currentPage: number;
		itemsPerPage: number;
		totalItems: number;
		totalPages: number;
	};
}

export interface ApiFormattedResponseData<TData extends {} = {}> {
	data: TData[];
	totalPages: number;
}

export type CustomFilters = Record<string, unknown>;

export interface Attachment {
	id: UUID;
	path: string;
	name: string;
	size: number;
	mimetype: AppMimeType;
}

export type UUID = ReturnType<typeof crypto.randomUUID>;

export type ApiErrorMessage = Record<string, ErrorCode | string>;

export interface ApiError {
	error: string;
	message: ApiErrorMessage;
	status: HttpStatusCode;
}

export interface AppError {
	status: HttpStatusCode;
	stack: (ErrorCode | string)[];
}

export enum MouseButtons {
	LEFT,
	MIDDLE,
	RIGHT,
}

export enum Currency {
	PLN = 'PLN',
	EUR = 'EUR',
}

export type AppMimeType = (typeof MIME_TYPES)[keyof typeof MIME_TYPES];
